import X from '../x.js';
import '../x-item/index.js';
import '../x-icon/index.js';

import commonCSS from '../../../css/common.js';

class XDialog extends X {
  static get properties() {
    return {
      isOpen: {
        type: Boolean
      }
    };
  }

  constructor() {
    super();

    this.isOpen = false;
  }

  render(target) {
    target.innerHTML = `
      <style>
        ${commonCSS}

        :host {
          display: block;
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;

          transition: transform 0.2s ease-in 0s;
          transform: translateY(100%);
        }

        :host([isOpen]) {
          transform: translateY(0);
        }

        button {
          height: 36px;
          width: 36px;
          border-radius: 0 18px 0 0;
        }
      </style>

      <div id="controls">
        <button id="close"><x-icon name="close" size="28"></x-icon></button>
      </div>
      <div id="content">
        <slot></slot>
      </div>
    `;
  }

  setup(target) {
    this.on(this.$.close, 'click', this.close);
  }

  open() {
    this.isOpen = true;
    this.emit('x-open');
  }

  close() {
    this.isOpen = false;
    this.emit('x-close');
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('x-dialog', XDialog);
